import styles from './index.module.scss'

export function buildComposerMainGridClassName(vm) {
  return [
    styles.mainInputGrid,
    vm.isExpanded ? styles.mainInputGridExpanded : '',
    styles.mainInputGridCompact,
    vm.effectiveStackedToolbar ? styles.mainInputGridStackedToolbar : '',
    vm.isEmailReply ? styles.mainInputGridEmailReply : '',
  ]
    .filter(Boolean)
    .join(' ')
}
